import { Vue, Component } from 'vue-property-decorator';
import { PutAccumulationsConfigurationsRequest } from 'supporter';
@Component
export default class ConfigModify extends Vue {
  public accumulationData: any = {
    basic: {},
    payment: {
      reviewAccumulation: {}
    },
    use: {},
  };
  public unitError: boolean = false;
  public expireNotificationChannelsAll: boolean = false
  public signUpError: boolean = false;
  public birthdayError: boolean = false;
  public appInstallError: boolean = false;
  public productMiniError: boolean = false;
  public productLimitError: boolean = false;
  public minimumUsePriceError: boolean = false;
  public rateError: boolean = false;
  public accumulationRateError: boolean = false;
  public nameError: boolean = false;
  public reviewError:boolean=false;

  public accumulationDisplayFormatTypeArr: any = [
    { value: 'FIXED_AMT', option: 'ACCUMULATION_CONFIGURATION_MODIFY_FORMATE_TYPE_FIXED_AMT' },
    { value: 'FIXED_RATE', option: 'ACCUMULATION_CONFIGURATION_MODIFY_FORMATE_TYPE_FIXED_RATE' },
    { value: 'FIRST_FIXED_RATE', option: 'ACCUMULATION_CONFIGURATION_MODIFY_FORMATE_TYPE_FIRST_FIXED_RATE' },
    { value: 'FIRST_FIXED_AMT', option: 'ACCUMULATION_CONFIGURATION_MODIFY_FORMATE_TYPE_FIRST_FIXED_AMT' },
  ];
  public accumulationReserveTimeArr: any = [
    { value: 'IMMEDIATE', option: 'ACCUMULATION_CONFIGURATION_MODIFY_RESERVE_TIME_IMMEDIATE' },
    { value: 'NEXTDAY', option: 'ACCUMULATION_CONFIGURATION_MODIFY_RESERVE_TIME_NEXTDAY' },
    { value: 'DAY_AFTER_TOMMOROW', option: 'ACCUMULATION_CONFIGURATION_MODIFY_RESERVE_TIME_DAY_AFTER_TOMMOROW' },
    { value: 'AFTER_A_WEEK', option: 'ACCUMULATION_CONFIGURATION_MODIFY_RESERVE_TIME_AFTER_A_WEEK' },
    { value: 'AFTER_TWO_WEEK', option: 'ACCUMULATION_CONFIGURATION_MODIFY_RESERVE_TIME_AFTER_TWO_WEEK' },
    { value: 'AFTER_TWENTY_DAYS', option: 'ACCUMULATION_CONFIGURATION_MODIFY_RESERVE_TIME_AFTER_TWENTY_DAYS' },
    { value: 'AFTER_THIRTY_DAYS', option: 'ACCUMULATION_CONFIGURATION_MODIFY_RESERVE_TIME_AFTER_THIRTY_DAYS' },
    { value: 'NEXT_MONTH', option: 'ACCUMULATION_CONFIGURATION_MODIFY_RESERVE_TIME_NEXT_MONTH' },
  ];
  public accumulationValidYearArr: any = [
    { value: '0', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_YEAR_0' },
    { value: '1', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_YEAR_1' },
    { value: '2', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_YEAR_2' },
    { value: '3', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_YEAR_3' },
    { value: '4', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_YEAR_4' },
    { value: '5', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_YEAR_5' },
  ];
  public accumulationValidMonthArr: any = [
    { value: '0', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_0' },
    { value: '1', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_1' },
    { value: '2', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_2' },
    { value: '3', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_3' },
    { value: '4', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_4' },
    { value: '5', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_5' },
    { value: '6', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_6' },
    { value: '7', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_7' },
    { value: '8', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_8' },
    { value: '9', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_9' },
    { value: '10', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_10' },
    { value: '11', option: 'ACCUMULATION_CONFIGURATION_MODIFY_VALID_MONTH_11' },
  ];
  public expireNotificationBeforeDayArr: any = [
    { value: '2', option: 'ACCUMULATION_CONFIGURATION_MODIFY_NOTIFICATION_BEFORE_DAY_2' },
    { value: '7', option: 'ACCUMULATION_CONFIGURATION_MODIFY_NOTIFICATION_BEFORE_DAY_7' },
    { value: '14', option: 'ACCUMULATION_CONFIGURATION_MODIFY_NOTIFICATION_BEFORE_DAY_14' },
    { value: '20', option: 'ACCUMULATION_CONFIGURATION_MODIFY_NOTIFICATION_BEFORE_DAY_20' },
    { value: '30', option: 'ACCUMULATION_CONFIGURATION_MODIFY_NOTIFICATION_BEFORE_DAY_30' },
  ];
  public productAccumulationBasisTypeArr: any = [
    { value: 'SALE_PRICE', option: 'ACCUMULATION_CONFIGURATION_MODIFY_BASIS_TYPE_SALE_PRICE' },
    { value: 'SALE_STANDARD_PRICE', option: 'ACCUMULATION_CONFIGURATION_MODIFY_BASIS_TYPE_SALE_STANDARD_PRICE' },
    { value: 'SALE_PROMOTION_PRICE', option: 'ACCUMULATION_CONFIGURATION_MODIFY_BASIS_TYPE_SALE_PROMOTION_PRICE' },
    { value: 'DISCOUNTED_PRICE', option: 'ACCUMULATION_CONFIGURATION_MODIFY_BASIS_TYPE_DISCOUNTED_PRICE' },
    { value: 'DISCOUNTED_STANDARD_PRICE', option: 'ACCUMULATION_CONFIGURATION_MODIFY_BASIS_TYPE_DISCOUNTED_STANDARD_PRICE' },
    { value: 'DISCOUNTED_PROMOTION_PRICE', option: 'ACCUMULATION_CONFIGURATION_MODIFY_BASIS_TYPE_DISCOUNTED_PROMOTION_PRICE' },

  ];


  public keyUpAccumulationRate(event: any): void {
    if (this.accumulationData.basic.accumulationRate === '.') {
      return;
    }
    const { value } = event.target;
    let regNum: any = new RegExp(/[^\d\.]/g);
    if (regNum.test(Number(this.accumulationData.basic.accumulationRate))) {
      this.accumulationRateError = true;
      this.accumulationData.basic.accumulationRate = this.accumulationData.basic.accumulationRate.replace(regNum, '')
    } else {
      this.accumulationRateError = false;
    }
    if (value.indexOf('.') < 0 && value.length > 1) {
      this.accumulationData.basic.accumulationRate = this.accumulationData.basic.accumulationRate.replace(/^[0]/g, '')
    }
    if (value > 100) {
      alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_1'));
      this.accumulationData.basic.accumulationRate = 0
      $('input[name="config.accumulationRate"]').val(0);
    }
    if (value.indexOf('.') >= 0) {
      let point = value.split('.');
      if (point[point.length - 1].length >= 2) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_2'));
        this.accumulationData.basic.accumulationRate = value.substring(0, value.length - (point.length - 1))
      }
    }
  };
  public changeAccumulationRate(event: any): void {
    const { value } = event.target;

    if (value.indexOf('.') >= 0) {
      let point = value.split('.');
      if (point.length > 2 || point[point.length - 1].length != 1) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_3'));
        this.accumulationData.basic.accumulationRate = value.substring(0, point[0].length)
      }
    }

  };
  public checkHasNumError(event: any, value: any, errTag: any): void {
    let regNum: any = new RegExp(/[0-9]/g);
    var pattern = new RegExp(/[^a-zA-Zㄱ-힣\s]/g);
    let _this: any = this;
    if (regNum.test(event.target.value)) {
      _this[errTag] = true;
      this.accumulationData.basic[value] = event.target.value.replace(regNum, '');
      return
    }
    if (pattern.test(event.target.value)) {
      _this[errTag] = true;
      this.accumulationData.basic[value] = event.target.value.replace(pattern, '');
      return
    }
    if (!regNum.test(event.target.value) && !pattern.test(event.target.value)) {
      _this[errTag] = false;
    }
  }
  public alertInputBlur(tag: any): void {
    let _this: any = this;
    _this[tag] = false;
  }


  public handleAccumulationValid(): void {
    let period: any = Number(this.accumulationData.basic.accumulationValidYear) * 12 + Number(this.accumulationData.basic.accumulationValidMonth)
    if (period < 1) {
      alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_4'));
      this.accumulationData.basic.accumulationValidYear = Math.floor((this.accumulationData.basic.accumulationValidPeriod / 12))
      this.accumulationData.basic.accumulationValidMonth = this.accumulationData.basic.accumulationValidPeriod % 12
      $('select[name="config.accumulationValidPeriodYear"]').val(Math.floor((this.accumulationData.basic.accumulationValidPeriod / 12)));
      $('select[name="config.accumulationValidPeriodMonth"]').val(this.accumulationData.basic.accumulationValidPeriod % 12);
    } else {
      this.accumulationData.basic.accumulationValidPeriod = period
    }
  }
  public removeComma(value: any): any {
    if (value) {
      return value.replace(/,/g, '');
    }
  }
  public checkNumBlur(status:string,value: any, errTag: any): void {
    let _this: any = this
    _this[errTag] = false;
    if (this.removeComma(this.accumulationData[status][value]) % 10 > 0) {
      alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_5'))
      this.accumulationData[status][value] = 0
    }
  }
  public handleOnlyNumAlert(event: any,status:string, value: string, errTag: any, tagFlag?: string): void {
    if (tagFlag === 'productLimitError') {
      this.productLimitError = false;
    }
    let regNum: any = new RegExp(/[^\d]/g);
    let _this: any = this
    let commaLast: any = this.accumulationData[status][value].indexOf(',') !== this.accumulationData[status][value].length - 1;
    let commaFirst: any = this.accumulationData[status][value].indexOf(',') !== 0;
    if (commaLast && commaFirst) {
      this.accumulationData[status][value] = this.removeComma(this.accumulationData[status][value])
    }
    if (regNum.test(this.accumulationData[status][value])) {
      _this[errTag] = true;
      this.accumulationData[status][value] = this.formatCurrency(Number(event.target.value.replace(/[^0-9]/ig, '')));
    } else {
      _this[errTag] = false;
      this.accumulationData[status][value] = event.target.value.replace(/[^0-9]/ig, '');
      if (Number(this.removeComma(this.accumulationData[status][value])) >= 0) {
        this.accumulationData[status][value] = this.formatCurrency(this.removeComma(this.accumulationData[status][value]));
      }
    }
  }
  public handleOnlyNumChange(event: any,status:string, value: string): void {
    this.accumulationData[status][value] = this.formatCurrency(Number(event.target.value.replace(/[^0-9]/ig, '')));
  }
  public handleReviewOnlyNumAlert(event: any,status:string,statusNext:string, value: string, errTag: any, tagFlag?: string): void {
    if (tagFlag === 'productLimitError') {
      this.productLimitError = false;
    }
    let regNum: any = new RegExp(/[^\d]/g);
    let _this: any = this
    let commaLast: any = this.accumulationData[status][statusNext][value].indexOf(',') !== this.accumulationData[status][statusNext][value].length - 1;
    let commaFirst: any = this.accumulationData[status][statusNext][value].indexOf(',') !== 0;
    if (commaLast && commaFirst) {
      this.accumulationData[status][statusNext][value] = this.removeComma(this.accumulationData[status][statusNext][value])
    }
    if (regNum.test(this.accumulationData[status][statusNext][value])) {
      this.accumulationData[status][statusNext][value] = this.formatCurrency(Number(event.target.value.replace(/[^0-9]/ig, '')));
      _this[errTag] = true;
    } else {
      _this[errTag] = false;
      this.accumulationData[status][statusNext][value] = event.target.value.replace(/[^0-9]/ig, '');
      if (Number(this.removeComma(this.accumulationData[status][statusNext][value])) >= 0) {
        this.accumulationData[status][statusNext][value] = this.formatCurrency(this.removeComma(this.accumulationData[status][statusNext][value]))
      }
    }
  }
  public handleReviewOnlyNumChange(event: any,status:string,statusNext:string, value: string): void {
    this.accumulationData[status][statusNext][value] = this.formatCurrency(Number(event.target.value.replace(/[^0-9]/ig, '')));
  }
  public checkReviewNumBlur(status:string,statusNext:string,value: any, errTag: any): void {
    let _this: any = this
    _this[errTag] = false;
    if (this.removeComma(this.accumulationData[status][statusNext][value]) % 10 > 0) {
      alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_5'))
      this.accumulationData[status][statusNext][value] = 0
    }
  }
  public checkMaxNumBlur(): void {
    this.productMiniError = false;
    if (Number(this.removeComma(this.accumulationData.use.productPriceMinimum)) > 999999999) {
      this.accumulationData.use.productPriceMinimum = null;
      this.productLimitError = true;
    } else {
      this.productLimitError = false;
    }
  }
  public checkMaxRate(): void {
    if (Number(this.accumulationData.use.maximumUseRate) > 100) {
      alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_6'));
      this.accumulationData.use.maximumUseRate = 0
    }
  }
  public handleCancel(): void {
    if (confirm(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_CONFIRM_1') as string)) {
      this.$router.go(-1)
    }
  }
  public formatterData(data: any): any {
    data.basic.accumulationValidYear = Math.floor((data.basic.accumulationValidPeriod / 12))
    data.basic.accumulationValidMonth = data.basic.accumulationValidPeriod % 12;
    this.accumulationData.basic.expireNotificationChannels = data.basic.expireNotificationChannels.filter(channel=> channel!== 'KAKAO');
    //NOTE : KAKAO 알림톡 삭제
    if (this.accumulationData.basic.expireNotificationChannels.length === 2) {
      this.expireNotificationChannelsAll = true;
    } else {
      this.expireNotificationChannelsAll = false;
    }
    if (data.basic.expireNotificationChannels.length === 0) {
      data.basic.expireNotificationChannels.push('EMAIL');
    }
    this.accumulationData.use.productPriceMinimum=this.accumulationData.use.productPriceMinimum.toLocaleString();
    this.accumulationData.use.minimumUsePrice=this.accumulationData.use.minimumUsePrice.toLocaleString();
    this.accumulationData.payment.signUpAccumulation=this.accumulationData.payment.signUpAccumulation.toLocaleString();
    this.accumulationData.payment.reviewAccumulation.photoReviewsAccumulation=this.accumulationData.payment.reviewAccumulation.photoReviewsAccumulation.toLocaleString();
    this.accumulationData.payment.reviewAccumulation.photoReviewsLength=this.accumulationData.payment.reviewAccumulation.photoReviewsLength.toLocaleString();
    this.accumulationData.payment.reviewAccumulation.reviewsAccumulation=this.accumulationData.payment.reviewAccumulation.reviewsAccumulation.toLocaleString();
    this.accumulationData.payment.reviewAccumulation.reviewsLength=this.accumulationData.payment.reviewAccumulation.reviewsLength.toLocaleString();
    this.accumulationData.payment.birthdayAccumulation=this.accumulationData.payment.birthdayAccumulation.toLocaleString();

    // 앱설치에대한 적립금 지불이 현재시점에서 적동하지않아 해당항목을 임시적으로 FE에서 미노출. 
    // "앱설치 적립금 사용안함"으로 고정
    this.accumulationData.payment.appInstallAccumulationUsable = false;
  }
  public save(tag: string): void {
    let request: PutAccumulationsConfigurationsRequest = {
      data: {
        temporary: this.accumulationData.temporary,
        use: {
          excludingReserveWhenUseCoupon: this.accumulationData.use.excludingReserveWhenUseCoupon,

          minimumUsePriceLimitUsable: this.accumulationData.use.minimumUsePriceLimitUsable,

          productPriceMinimumLimitUsable: this.accumulationData.use.productPriceMinimumLimitUsable,

          maximumUseRateLimitUsable: this.accumulationData.use.maximumUseRateLimitUsable,

          productPriceMinimum: Number(this.accumulationData.use.productPriceMinimum.replace(/,/g, '')),

          minimumUsePrice: Number(this.accumulationData.use.minimumUsePrice.replace(/,/g, '')),

          excludingReserveWhenUseAccumulation: this.accumulationData.use.excludingReserveWhenUseAccumulation,

          maximumUseRate: this.accumulationData.use.maximumUseRate,
        },
        memo: this.accumulationData.memo,
        payment: {
          signUpAccumulation: Number(this.accumulationData.payment.signUpAccumulation.replace(/,/g, '')),

          signUpAccumulationUsable: this.accumulationData.payment.signUpAccumulationUsable,

          reviewAccumulation: {
            photoReviewsAccumulation: Number(this.accumulationData.payment.reviewAccumulation.photoReviewsAccumulation.replace(/,/g, '')) ,
            photoReviewsLength: Number(this.accumulationData.payment.reviewAccumulation.photoReviewsLength.replace(/,/g, '')) ,
            reviewsAccumulation: Number(this.accumulationData.payment.reviewAccumulation.reviewsAccumulation.replace(/,/g, '')),
            reviewsLength: Number(this.accumulationData.payment.reviewAccumulation.reviewsLength.replace(/,/g, '')),
          } as any,

          appInstallAccumulation: this.accumulationData.payment.appInstallAccumulation,

          reviewAccumulationUsable: this.accumulationData.payment.reviewAccumulationUsable,

          productAccumulationBasisType: this.accumulationData.payment.productAccumulationBasisType,

          appInstallAccumulationUsable: this.accumulationData.payment.appInstallAccumulationUsable,

          birthdayAccumulation: Number(this.accumulationData.payment.birthdayAccumulation.replace(/,/g, '')),

          birthdayAccumulationUsable: this.accumulationData.payment.birthdayAccumulationUsable,
        },
        mallNo: Number(this.$route.params.mallNo),
        basic: {
          accumulationValidPeriod: this.accumulationData.basic.accumulationValidPeriod,

          expireNotificationUsable: this.accumulationData.basic.expireNotificationUsable,

          accumulationUnit: this.accumulationData.basic.accumulationUnit,

          memberAccumulationUsable: this.accumulationData.basic.memberAccumulationUsable,

          expireNotificationBeforeDay: this.accumulationData.basic.expireNotificationBeforeDay,

          accumulationRate: this.accumulationData.basic.accumulationRate,

          expireNotificationChannels: this.accumulationData.basic.expireNotificationChannels,
          accumulationReserveTime: this.accumulationData.basic.accumulationReserveTime,

          accumulationName: this.accumulationData.basic.accumulationName,

          productAccumulationUsable: this.accumulationData.basic.productAccumulationUsable,

          accumulationDisplayFormatType: this.accumulationData.basic.accumulationDisplayFormatType,
        },
      }
    }

    if (!this.saveCheck(request.data)) {
      return
    }
    let message: any = ''
    if (tag === 'temporary') {
      request.data.temporary=true;
      message = this.$t('ACCUMULATION_CONFIGURATION_MODIFY_CONFIRM_2')
    } else {
      request.data.temporary=false;
      message = this.$t('ACCUMULATION_CONFIGURATION_MODIFY_CONFIRM_3')
    }
    if (!confirm(message)) {
      return;
    }
    this.$api.putAccumulationsConfigurations(request).then((): any => {
      if (tag === 'temporary') {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_8'))
      } else {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_7'))
      }
      this.$router.go(-1)
    })
  }
  public saveCheck(data: any): any {
    if (!data.basic.accumulationRate && data.basic.accumulationRate !==0) {
      alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_9'));
      $(this.$refs.accumulationRate).focus();
      return false;
    }

    if (!data.basic.accumulationName) {
      alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_10'));
      $('input:text[name="config.accumulationName"]').focus();
      return false;
    }

    if (!data.basic.accumulationReserveTime) {
      alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_11'));
      $('select[name="config.accumulationGivePoint"]').focus();
      return false;
    }

    if (!data.basic.accumulationValidPeriod || parseInt(data.basic.accumulationValidPeriod) === 0) {
      alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_12'))
      $('select[name="config.accumulationValidPeriodYear"]').focus();
      return false;
    }

    if (data.basic.expireNotificationUsable) {
      if (!data.basic.expireNotificationBeforeDay) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_13'))
        $(this.$refs.expireNotificationBeforeDay).focus();
        return false;
      }
      if (data.basic.expireNotificationChannels.length === 0) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_14'))
        $('input:checkbox[name="config.accumulationExpireNotificationToolTypes"]').focus();
        return false
      }
    }

    if (data.payment.signUpAccumulationUsable) {
      if (!Number(data.payment.signUpAccumulation)) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_15'))
        $('input:text[name="config.signUpAccumulation"]').focus();
        return false;
      }
    }

    if (data.payment.birthdayAccumulationUsable) {
      if (!Number(data.payment.birthdayAccumulation)) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_16'))
        $('input:text[name="config.birthdayAccumulation"]').focus();
        return false;
      }
    }

    // 앱설치에대한 적립금 지불이 현재시점에서 적동하지않아 해당항목을 임시적으로 FE에서 미노출.
    // 유효성검사 항목에서 제외
    // if (data.payment.appInstallAccumulationUsable) {
    //   if (!Number(data.payment.appInstallAccumulation)) {
    //     alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_17'))
    //     $('input:text[name="config.appInstallAccumulation"]').focus();
    //     return false;
    //   }
    // }

    if (data.payment.reviewAccumulationUsable) {
      if (!Number(data.payment.reviewAccumulation.reviewsLength)) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_18'))
        $('input:text[name="config.reviewsAccumulationDetail.reviewsLength"]').focus();
        return false;
      }
      if (!Number(data.payment.reviewAccumulation.reviewsAccumulation)) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_19'))
        $('input:text[name="config.reviewsAccumulationDetail.reviewsAccumulation"]').focus();
        return false;
      }
      if (!Number(data.payment.reviewAccumulation.photoReviewsLength)) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_20'));
        $('input:text[name="config.reviewsAccumulationDetail.photoReviewsLength"]').focus();
        return false;
      }
      if (!Number(data.payment.reviewAccumulation.photoReviewsAccumulation)) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_21'));
        $('input:text[name="config.reviewsAccumulationDetail.photoReviewsAccumulation"]').focus();
        return false;
      }
    }

    if (data.use.productPriceMinimumLimitUsable) {
      if (!Number(data.use.productPriceMinimum)) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_22'))
        $('input:text[name="config.accumulationUseMinProductPrice"]').focus();
        return false;
      }
    }

    if (data.use.minimumUsePriceLimitUsable) {
      if (!Number(data.use.minimumUsePrice)) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_23'))
        $('input:text[name="config.accumulationUseMinPrice"]').focus();
        return false;
      }
    }

    if (data.use.maximumUseRateLimitUsable) {
      if (!Number(data.use.maximumUseRate)) {
        alert(this.$t('ACCUMULATION_CONFIGURATION_MODIFY_ALERT_24'));
        $('input:text[name="config.accumulationUseMaxRate"]').focus();
        return false;
      }
    }
    return true;
  }

  private formatCurrency(num: number): string {
    if (num >= 0) {
      let number = num.toString();
      let tempNum = '';
      while (number.length > 3) {
        tempNum = ',' + number.slice(-3) + tempNum;
        number = number.slice(0, number.length - 3);
      }
      if (number) {
        tempNum = number + tempNum;
      }
      return tempNum;
    } else {
      return '0';
    }
  }
}
